import { NodeRefFragment } from "@bonliva-crm/graphql";

export function nodeRefToUri(nodeRef: NodeRefFragment) {
  return `${nodeRef.NodeType.toLowerCase()}/${nodeRef.NodeID}`;
}

export function nodeGetTypeAndId(nodeRef: NodeRefFragment) {
  return { type: nodeRef.NodeType.toLowerCase(), id: nodeRef.NodeID };
}
